import { render } from "./MaterialsBooksDetail.vue?vue&type=template&id=50566298&scoped=true"
import script from "./MaterialsBooksDetail.vue?vue&type=script&lang=js"
export * from "./MaterialsBooksDetail.vue?vue&type=script&lang=js"

import "./MaterialsBooksDetail.vue?vue&type=style&index=0&id=50566298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50566298"]])

export default __exports__